<mat-card>
  <mat-card-content>
    <h3 class="title mb-4">
      <strong>{{ data && data.username ? 'Edit' : 'Create' }} User</strong>
    </h3>
    <form [formGroup]="form" autocomplete="off" class="d-flex flex-column gap-3">
      <mat-form-field class="w-100 d-flex flex-column gap-1">
        <input [readonly]="this.idParam" autocomplete="off" formControlName="username" matInput placeholder="User Name">
        <mat-error *ngIf="form.get('username')?.hasError('required')">
          User Name cannot be blank
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-100 d-flex flex-column gap-1">
        <input autocomplete="off" formControlName="password" matInput placeholder="Password" type="password">
        <mat-error *ngIf="form.get('password')?.hasError('required')">
          Password cannot be blank
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-100 d-flex flex-column gap-1">
        <input autocomplete="off" formControlName="fullName" matInput placeholder="Full Name">
        <mat-error *ngIf="form.get('fullName')?.hasError('required')">
          Full Name cannot be blank
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-100 d-flex flex-column gap-1">
        <input autocomplete="off" formControlName="email" matInput placeholder="Email">
      </mat-form-field>
      <mat-form-field class="w-100 d-flex flex-column gap-1">
        <mat-select formControlName="userCompany" multiple placeholder="Company">
          @for (userCompany of userCompanyOptions$ | async; track userCompany) {
          <mat-option [value]="userCompany.companyCode">
          {{ userCompany.companyCode }} - {{ userCompany.companyName }}
          </mat-option>
          }
        </mat-select>
        <mat-error *ngIf="form.get('userCompany')?.hasError('required')">
          Company cannot be blank
        </mat-error>
      </mat-form-field>
    </form>
    <div class="d-flex justify-content-end pt-4 gap-2">
      <button (click)="onCancelClick()" [disabled]="isLoading" mat-raised-button>
        Cancel
      </button>
      <button (click)="onSubmitClick()" [disabled]="isLoading" color="primary" mat-raised-button>
        {{ data && data.username ? 'Save' : 'Submit' }}
      </button>
    </div>
  </mat-card-content>
</mat-card>
